import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import styles from './Badge.module.sass';

const Badge = ({children, tooltip}: any) => {
    if (tooltip) {
        return <Tooltip content={tooltip}>
            <div className={styles.badge}>
                {children}
            </div>
        </Tooltip>;
    }
 
    return <div className={styles.badge}>
        {children}
    </div>;
}

export default Badge;